import { useCallback, useEffect, useState } from "react";

const API = process.env.REACT_APP_CIRCLE_WATCH_API_URL;

export const useInvite = (token) => {
  const [state, setState] = useState({ loading: true, status: null, data: null });

  const load = useCallback(async (signal) => {
    setState({ loading: true, status: null, data: null });
    if (!token || token.length > 512) {
      setState({ loading: false, status: "invalid", data: null });
      return;
    }
    try {
      const res = await fetch(`${API}/invite/${encodeURIComponent(token)}/info`, {
        signal,
        cache: "no-store",
        credentials: "omit",
        referrerPolicy: "no-referrer",
      });
      if (!res.ok) throw new Error("bad response");
      const data = await res.json();
      setState({ loading: false, status: data.status, data });
    } catch (e) {
      if (e.name !== "AbortError") setState({ loading: false, status: "error", data: null });
    }
  }, [token]);

  useEffect(() => {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 12000);
    load(ctrl.signal).finally(() => clearTimeout(timer));
    return () => ctrl.abort();
  }, [load]);

  return { ...state, retry: () => load() };
};
